import { useEffect } from 'react';

/**
 * useJsonLd — injects (and removes) a single <script type="application/ld+json">
 * into <head> for the lifetime of the component. Passing null/undefined removes the tag.
 */
export const useJsonLd = (data, id = 'ld-json-page') => {
  useEffect(() => {
    if (!data) return undefined;
    const existing = document.getElementById(id);
    const script = existing || document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    if (!existing) document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, [data, id]);
};

export default useJsonLd;
